import { lazy } from "react";

// Stale tab after a deploy: old chunk hashes are gone, so reload once to pick up the new build.
const KEY = "samtwo_chunk_reload_at";
const WINDOW_MS = 30000;

const isChunkError = (err) =>
  err?.name === "ChunkLoadError" || /Loading (CSS )?chunk [\w-]+ failed/i.test(err?.message || "");

// True when a reload was triggered; false means the caller should surface the error.
export const reloadOnceForChunk = (err) => {
  if (!isChunkError(err)) return false;
  let last = 0;
  try { last = Number(sessionStorage.getItem(KEY) || 0); } catch {}
  if (Date.now() - last < WINDOW_MS) return false;
  try { sessionStorage.setItem(KEY, String(Date.now())); } catch { return false; }
  window.location.reload();
  return true;
};

export const lazyPage = (load) =>
  lazy(() =>
    load().catch((err) => {
      if (!reloadOnceForChunk(err)) throw err;
      return new Promise(() => {});
    })
  );
